import useFormUtility from "../utilities/useFormUtility";
import useDateUtility from "../utilities/useDateUtility";
import MenuPage from "../components/MenuPage";
import MenuPageItemDiscard from "../components/MenuPageItemDiscard";
import MenuPageItemOk from "../components/MenuPageItemOk";
import Table from "../components/Table";
import useRuleUtility from "../utilities/useRuleUtility";

export default function RuleSection({ data, isPickup, onDiscard, onOk }) {

    const ruleUtility = useRuleUtility();

    const ruleType = ruleUtility.getRuleType(data?.ruleType);

    var formUtility = useFormUtility(
        data
            ? {
                id: data.id,
                ruleType: data.ruleType.toString(),
                condition: data.condition.toString(),
                value: ["string", "int", "decimal", "attribute"].includes(ruleType?.dataType) ? data.value : "",
                valueDate: ruleType?.dataType === "date" && ![1,2].includes(data.condition) ? new Date(data.value) : null,
                valueDateTime: ruleType?.dataType === "datetime" && ![1, 2].includes(data.condition) ? new Date(data.value) : null,
                valueDates: ruleType?.dataType.startsWith("date") && [1, 2].includes(data.condition) ? data.value.split(",") : [],
                valueDayOfWeek: ruleType?.dataType === "dayOfWeek" ? data.value : "1",
                orGroup: data.orGroup
            }
            : {
                id: null,
                ruleType: isPickup ? "2" : "1",
                condition: isPickup ? "2" : "1",
                valueDayOfWeek: "1",
                valueDate: null,
                valueDateTime: null,
                valueDates: [],
                orGroup: null
            }
    );

    const dateUtility = useDateUtility();

    var dataRuleType = ruleUtility.getRuleType(parseInt(formUtility.data.ruleType));

    var conditions = ruleUtility.conditions
        .filter(c => dataRuleType?.conditions?.includes(c.value));

    function handleChangeRuleType(event) {
        var fieldValues = [];
        var ruleType = ruleUtility.getRuleType(parseInt(event.target.value));
        fieldValues.push({ field: "ruleType", value: ruleType.value.toString() });
        if (!ruleType?.conditions?.includes(formUtility.data.condition))
            fieldValues.push({ field: "condition", value: ruleType?.conditions[0].toString() });

        formUtility.handleChange(fieldValues);
    }

    function handleAddDate(e) {
        e.preventDefault();

        var dataType = ruleUtility.getRuleType(formUtility.data.ruleType)?.dataType;
        var field = dataType === "date" ? "valueDate" : "valueDateTime";
        var dateValue = formUtility.data[field];
        
        if (!dateValue)
            return;

        var dates = [...formUtility.data.valueDates];

        var dateFormatted = dataType === "date"
            ? dateUtility.toDateString(dateValue)
            : dateUtility.toDateTimeString(dateValue);

        var idx = dates.indexOf(dateFormatted);

        if (idx >= 0)
            return;

        dates.push(dateFormatted);

        formUtility.handleChange([{ field: "valueDates", value: dates }]);
    }

    function handleRemoveDate(idx) {
        if (idx < 0)
            return;

        var dates = [...formUtility.data.valueDates];

        dates.splice(idx, 1);

        formUtility.handleChange([{ field: "valueDates", value: dates }]);
    }

    function handleOk() {
        var errors = [];
        var dataType = ruleUtility.getRuleType(formUtility.data.ruleType).dataType;
        var sValues = (formUtility.data.value ?? "")
            .split(",")
            .map(x => x.trim())
            .filter((v, i, a) => v !== "" && a.indexOf(v) === i)
            .sort();
        
        ///VALIDATE///
        switch (dataType) {
            case "int":
            case "decimal":
                if (sValues.length < 1)
                    errors.push("Value is required.");
                else if (formUtility.data.value?.includes(",") || sValues.find(v => isNaN(Number(v))))
                    errors.push("Invalid Value.");
                break;
            case "date":
            case "datetime":
                if (["1", "2"].includes(formUtility.data.condition)) {
                    if (formUtility.data.valueDates.length < 1)
                        errors.push("At least one date is required.");
                }
                else if (isNaN(Date.parse(dataType === "date" ? formUtility.data.valueDate : formUtility.data.valueDateTime))) {
                    errors.push("A valid date is required.");
                }

                break;
            case "dayOfWeek":
                if (dataType === "dayOfWeek" && (!formUtility.data.valueDayOfWeek || !["1", "2", "3", "4", "5", "6", "7"].includes(formUtility.data.valueDayOfWeek)))
                    errors.push("A valid date is required.");

                break;
            case "attribute":
                if (sValues.length < 1)
                    errors.push("Value is required.");
                else if (sValues.map(v => v.split(":")).find(v => v.length !== 2 || v[0].trim().length < 1))
                    errors.push("Invalid Value.");

                break;
            default:
                if (sValues.length < 1)
                    errors.push("Value is required.");

                break;
        }

        if (formUtility.data.orGroup && formUtility.data.orGroup.toString().trim().length > 0 && (formUtility.data.orGroup.toString().includes(".") || isNaN(Number(formUtility.data.orGroup.toString().trim())) || parseInt(formUtility.data.orGroup.toString().trim()) < 1))
            errors.push("Invalid OR Group.");

        if (errors.length > 0)
            return formUtility.showNotification(2, errors[0]);

        if (!onOk)
            return;

        ///FORMAT VALUES///
        var valueFormatted = null;
        var orGroup = formUtility.data.orGroup && formUtility.data.orGroup.toString().trim().length > 0 ? parseInt(formUtility.data.orGroup.toString().trim()) : null;

        switch (dataType) {
            case "int":
                valueFormatted = sValues.map(v => parseInt(v).toString()).join(",");
                break;
            case "decimal":
                valueFormatted = sValues.map(v => parseFloat(v).toString()).join(",");
                break;
            case "date":
                valueFormatted = ["1", "2"].includes(formUtility.data.condition)
                    ? formUtility.data.valueDates.map(v => dateUtility.toDateString(v)).join(",")
                    : dateUtility.toDateString(formUtility.data.valueDate);
                break;
            case "datetime":
                valueFormatted = ["1", "2"].includes(formUtility.data.condition)
                    ? formUtility.data.valueDates.map(v => dateUtility.toDateTimeString(v)).join(",")
                    : dateUtility.toDateTimeString(formUtility.data.valueDateTime);
                break;
            case "dayOfWeek":
                valueFormatted = formUtility.data.valueDayOfWeek;
                break;
            case "attribute":
                valueFormatted = sValues.map(v => v.split(":")).map(v => `${v[0].trim()}:${v[1].trim()}`).join(",");
                break;
            default:
                valueFormatted = sValues.join(",");
                break;
        }

        var result = {
            id: formUtility.data.id,
            ruleType: parseInt(formUtility.data.ruleType),
            condition: parseInt(formUtility.data.condition),
            value: valueFormatted,
            orGroup: orGroup
        };

        console.log("onOk result");
        console.log(result);
        onOk(result);
    }

    return (
        <div className="rule-section">
            <MenuPage>
                <MenuPageItemDiscard formUtility={formUtility} onClick={onDiscard} />
                <MenuPageItemOk formUtility={formUtility} onClick={handleOk} />
            </MenuPage>
            <div>
                <div className="form-group">
                    <label>Rule Type</label>
                    <select
                        name="ruleType"
                        className="form-control"
                        onChange={handleChangeRuleType}>
                        {
                            ruleUtility.ruleTypes.map(x =>
                                <option value={x.value} selected={formUtility.data.ruleType === x.value.toString()}>{x.name}</option>
                            )
                        }
                    </select>
                    {
                        ["date", "datetime", "dayOfWeek"].includes(dataRuleType?.dataType)
                            ? <p>Warning: Date based rules are calculated at the time Shopify asks for rates.  Shopify may also cache rates for a short period and users may also take time to complete the order after getting rates.</p>
                            : null
                    }
                </div>
                <div className="form-group">
                    <label>Condition</label>
                    <select
                        name="condition"
                        onChange={formUtility.handleChangeControl}
                        className="form-control">
                        {
                            conditions.map(x =>
                                <option value={x.value} selected={formUtility.data.condition === x.value.toString()}>{x.name}</option>
                            )
                        }
                    </select>
                </div>
                <div className="form-group">
                    <label>Value</label>
                    {
                        dataRuleType?.dataType === "dayOfWeek"
                            ?
                            <select
                                name="valueDayOfWeek"
                                onChange={formUtility.handleChangeControl}
                                className="form-control">
                                {
                                    dateUtility.daysOfWeek.map(x => <option value={x.value} selected={formUtility.data.valueDayOfWeek === x.value.toString()}>{x.name}</option>)
                                }
                            </select>
                            : null
                    }
                    {
                        ["date", "datetime"].includes(dataRuleType?.dataType)
                            ?
                            <div className={["1", "2"].includes(formUtility.data.condition) ? "add-date" : null}>
                                <input
                                    name={dataRuleType?.dataType === "date" ? "valueDate" : "valueDateTime"}
                                    className="form-control"
                                    type={dataRuleType?.dataType === "date" ? "date" : "datetime-local"}
                                    value={dataRuleType?.dataType === "date" ? formUtility.data.valueDate : formUtility.data.valueDateTime}
                                    onChange={formUtility.handleChangeControl} />
                                {
                                    ["1", "2"].includes(formUtility.data.condition)
                                        ? 
                                        <>
                                            <span>&nbsp;<button className="btn-add-date btn btn-yellow" onClick={handleAddDate} >Add</button></span>
                                            <Table
                                                formUtility={formUtility}
                                                data={formUtility.data.valueDates.map(d => ({ date: d }))}
                                                mappings={
                                                    [
                                                        {
                                                            header: `${dataRuleType?.dataType === "date" ? "Date" : "Date Time"}`,
                                                            dataType: dataRuleType?.dataType,
                                                            field: "date"
                                                        }
                                                    ]
                                                }
                                                pageSize={5}
                                                onRemove={handleRemoveDate}
                                            />
                                        </>
                                        : null
                                }
                            </div>
                            : null
                    }
                    {
                        !["date", "datetime", "dayOfWeek"].includes(dataRuleType?.dataType)
                            ?
                            <input
                                name="value"
                                className="form-control"
                                type="text"
                                value={formUtility.data.value}
                                onChange={formUtility.handleChangeControl} />
                            : null
                    }
                    {
                        dataRuleType?.dataType === "attribute"
                            ? <p>Comma separated list of attribute name and the value, the value is used with the condition.  Format is 'name:value, name2:value2'.</p>
                            : null
                    }
                </div>
                <div class="form-group">
                    <label>OR Group</label>
                    <input
                        name="orGroup"
                        className="form-control"
                        type="text"
                        value={formUtility.data.orGroup}
                        onKeyDown={(e) => formUtility.onKeyDownNumberOnly(e, false, true)}
                        onChange={formUtility.handleChangeControl}
                        maxlength="9" />
                    <p>If not left blank, only one rule within the same Or Group needs to be valid, allows you to use an OR condition instead of AND condition for rules.</p>
                </div>
            </div>
        </div>
    );
}